import React from 'react'

export const HeadlessError = React.lazy(
  () => import(/* webpackChunkName: "headless-error-modal" */ '../modals/headless-error'),
)
